<div class="container">
  <mat-form-field [style.width.px]=550>
    <input matInput [(ngModel)]="myComment" maxlength="256" placeholder="{{'common.Comment' | translate}}">
  </mat-form-field>
    <br />
    <button type="button" (click)="dialogRef.close(myComment)">{{'common.Save' | translate}}</button>
    <button type="button" (click)="dialogRef.close()">{{'common.Cancel' | translate}}</button>
</div>
